// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"actioncable","552":"chartjs"}[chunkId] || chunkId) + "-" + {"76":"7c79dd4c984dc7950204","343":"a95b4af91b5c4fe98a51","552":"951ff403a15543ca25c1"}[chunkId] + ".chunk.js";
};